import {useInfiniteQuery} from 'react-query';
import {NotificationCategoryType} from '../../../pages/notification/constants/notificationCategoryItems';
import useInfiniteScroll from '../../../utilities/hooks/useInfiniteScroll';
import {getNotificationsList} from './getNotificationsList';
import {Notification} from './type';

const useGetNotificationsList = (category?: NotificationCategoryType) => {
  const {
    data: rawData,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ['get-notifications-list', category],
    queryFn: ({pageParam = 1}) => getNotificationsList(pageParam, category),
    getNextPageParam: lastPage => {
      if (!lastPage.next) return undefined;
      const url = new URL(lastPage.next);
      const page = url.searchParams.get('page');
      return page ? Number(page) : undefined;
    },
  });

  const data: Notification[] =
    rawData?.pages.flatMap(page => page.results) ?? [];

  const loaderRef = useInfiniteScroll({
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  });

  return {
    data,
    isLoading,
    loaderRef,
    isFetchingNextPage,
    refetch,
  };
};

export default useGetNotificationsList;
